export function getMenuListContainerRole({ mode }) {
    if (mode === "select") {
        return "listbox";
    }
    if (mode === "menu") {
        return "menu";
    }
    return "list";
}
